import { IdentificacionTextField } from "@/erp/compras/proveedores/shared/components/IdentificacionProveedorTextField";
// import FormCoordendas from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/form_coordendas";
import { gridSize, gridSizeMdLg12, gridSizeMdLg3, gridSizeMdLg6, ROUTER_PATHS, TipoIdentificacionEnumChoice } from "@/shared";
import { useFetchCoberturasCiudadEnabled, useFetchCoberturasProvincia, useFetchSearchIdentification } from "@/shared/actions/erp";
import { useFetchPostSolicitudCanje, useFetchPutSolicitudCanje } from "@/shared/actions/erp/marketing";
import { useFetchPostSolicitudEvento, useFetchPutSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import { CustomAutocomplete, CustomAutocompleteArrString, CustomTextArea, CustomTextField, CustomTextFieldNumberComponente, SampleCheckbox, SampleDatePicker, SingleIconButton, SingleTableBoxScene } from "@/shared/components/ui";

import { AlertSeverityEnum, City, IDataRuc, ISolicitudCanje, ISolicitudEvento, Province, ServicioCanejeEvento, TIPO_PLAN_CORPORATIVO_CHOICE, TipoDocumentoNameEnum, TipoEventoEnumChoice, TipoPlanCorporativo, TipoSolicitudesEnum, TipoSolicitudesEnumChoice } from "@/shared/interfaces";
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import { Grid, Typography } from "@mui/material";
import SearchIcon from '@mui/icons-material/Search';
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useUiStore } from "@/store/ui";
import CustomCoordendasForm from "@/erp/venta-corporativa/preventa_corporativo/shared/form_coordenadas/CustomCoordendasForm";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
type SaveSolicitudesEventoCanjeProps = {
  title: string;
  dataSolicitud?: Partial<ISolicitudCanje> & Partial<ISolicitudEvento>;
}
type SaveFormData = Omit<Partial<ISolicitudCanje>, 'identificacion'> & Omit<Partial<ISolicitudEvento>, 'identificacion'> & {
  tipo_formulario?: string;
  observacion_canje?: string;
  observacion_evento?: string;
  tipo_identificacion: string;
  identificacion: string;
}

const TIPO_SERVCICIO = [...TIPO_PLAN_CORPORATIVO_CHOICE, TipoPlanCorporativo.PYME, ServicioCanejeEvento.HOME];

export default function SaveSolicitudesEventoCanje({ title, dataSolicitud }: SaveSolicitudesEventoCanjeProps) {

  const navigate = useNavigate()
  const isEditPage = !!dataSolicitud
  const RETURN_URL = ROUTER_PATHS.marketing.solicitudesCanjeEventoNav

  //*Tipo Solicitud
  // const [selectedSolicitud, ]=useState<string>('');
  const [selectedProvince, setSelectedProvince] = useState('');
  const [, setSelectedCity] = useState('');

  ///* global state -----------------
  const setAlert = useUiStore.getState().setAlert;

  //*
  const form = useForm<SaveFormData>({})
  const watchOptionSelected = form.watch().tipo_formulario

  const {
    control,
    formState: { errors },
  } = form

  const watchedTipoIdentificacion = form.watch().tipo_identificacion

  const { data: provinceByCountry, isLoading: isLoadingProvinceByCountry } =
    useFetchCoberturasProvincia({
      page_size: 1000,
      cobertura: undefined,
      estado: true
    });

  const { data: citiesByProvince, isLoading: isLoadingCities } =
    useFetchCoberturasCiudadEnabled({
      enabled: !!form.watch().provincia,
      params: {
        provincia: selectedProvince,
        page_size: 1000,
        estado: true,
        cobertura: undefined,
      },
    });

  const { mutate: putSolicitudCanje, } = useFetchPutSolicitudCanje({
    enableSuccessAlert: true,
    navigate,
    enableRedirect: true,
    returnUrl: RETURN_URL
  })
  const { mutate: putSolicitudEvento, } = useFetchPutSolicitudEvento({
    enableSuccessAlert: true,
    navigate,
    enableRedirect: true,
    returnUrl: RETURN_URL
  })

  const { mutate: postSolicitudCanje, } = useFetchPostSolicitudCanje({
    enableSuccessAlert: true,
    navigate,
    enableRedirect: true,
    returnUrl: RETURN_URL
  })
  const { mutate: postSolicitudEvento, } = useFetchPostSolicitudEvento({
    enableSuccessAlert: true,
    navigate,
    enableRedirect: true,
    returnUrl: RETURN_URL
  })
  const consultaIdentificacion = useFetchSearchIdentification({
    customSuccessMessage: 'Datos de identificación encontrados.',
  });

  const onSubmit = () => {

    if (watchOptionSelected == TipoSolicitudesEnum.CANJE) {
      form.reset({
        ...form.getValues(),
        observaciones: {
          observacion_canje: form.getValues().observacion_canje
        },
      })
      if (!!dataSolicitud) {
        putSolicitudCanje({
          id_solicitud_canje: dataSolicitud.id_solicitud_canje,
          ...form.getValues(),
          observaciones: {
            observacion_canje: form.getValues()?.observacion_canje
          }
        })
      } else {
        postSolicitudCanje(form.getValues())
      }
    }
    if (watchOptionSelected == TipoSolicitudesEnum.EVENTO) {
      form.reset({
        ...form.getValues(),
        observaciones: {
          observacion_evento: form.getValues().observacion_evento
        },
      })
      if (!!dataSolicitud) {
        putSolicitudEvento({
          id_solicitud_evento: dataSolicitud.id_solicitud_evento,
          ...form.getValues(),
          observaciones: {
            observacion_evento: form.getValues()?.observacion_evento
          }
        })
      } else {
        postSolicitudEvento(form.getValues())
      }
    }
    return
  }


  const handleConsultaIdentificacion = async (value: string) => {
    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.CEDULA) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      const { data } = res;
      if (!data) return;

      form.setValue('razon_social', data?.razon_social);
      form.setValue('responsable', data?.razon_social);

      return;
    }

    if (watchedTipoIdentificacion === TipoDocumentoNameEnum.RUC) {
      const res = await consultaIdentificacion.mutateAsync({
        identificacion: value,
      });
      const data: IDataRuc = res?.data as unknown as IDataRuc;

      form.setValue('razon_social', data?.razonSocial);
      form.setValue('responsable', data?.razonSocial);

      return;
    }
  };

  useEffect(() => {
    form.reset({})
    // dataSolicitud?.id_solicitud_canje?TipoSolicitudesEnum.CANJE:TipoSolicitudesEnum.EVENTO
    if (dataSolicitud) {
      if (dataSolicitud?.id_solicitud_canje) {
        form.reset({
          ...form.getValues(),
          ...dataSolicitud,
          tipo_formulario: TipoSolicitudesEnum.CANJE,
          observacion_canje: dataSolicitud?.observaciones?.observacion_canje
        })
      }
      if (dataSolicitud?.id_solicitud_evento) {
        form.reset({
          ...form.getValues(),
          ...dataSolicitud,
          tipo_formulario: TipoSolicitudesEnum.EVENTO,
          observacion_evento: dataSolicitud?.observaciones?.observacion_evento
        })
      }

      console.log(form.getValues())
    }

  }, []);

  ///const{control}= form;

  return (
    <>
      <SingleTableBoxScene
        // title={title}
        // iconRedirect={<FormatListBulletedIcon />}
        // enableRedirect={true}
        // backPageUrl="/activos/asignaciones"
        // textRedirect="marketing"
        // enableCreateOrEditBtn={true}
        // textCreateOrEditBtn='Save'
        // visibleReport={false}
        // fnCreateOrEdit={() => { }}
        // urlRedirect={''}
        py={4}
        title={title}
        iconRedirect={<FormatListBulletedIcon />}
        enableRedirect={true}
        textRedirect='Solicitudes'
        textCreateOrEditBtn='Guardar'
        urlRedirect={ROUTER_PATHS.marketing.solicitudesCanjeEventoNav}
        visibleReport={false}
        fnCreateOrEdit={form.handleSubmit(onSubmit, (error) => {
          console.log({ error })
        })}
        enableCreateOrEditBtn={true}
        gridSizeTitle={gridSizeMdLg6}
        gridSizeBtnAccion={gridSizeMdLg6}
      >
        <Grid
          container
          {...gridSizeMdLg12}
          spacing={3}
          gap={2} pb={4}
        >
          <Grid item {...gridSizeMdLg6}>
            <Typography variant="subtitle1">
              Seleccione el tipo de solicitud:
            </Typography>
          </Grid>
          <Grid item {...gridSizeMdLg6}>
            {
              dataSolicitud ?
                <CustomAutocompleteArrString
                  label="TIPO DE SOLICITUD"
                  name="tipo_formulario"
                  options={TipoSolicitudesEnumChoice}
                  isLoadingData={false}
                  control={control}
                  error={errors.tipo_formulario}
                  helperText={errors.tipo_formulario?.message}
                  size={gridSizeMdLg12}
                  disabled
                />
                :
                <CustomAutocompleteArrString
                  label="TIPO DE SOLICITUD"
                  name="tipo_formulario"
                  options={TipoSolicitudesEnumChoice}
                  defaultValue={''}
                  isLoadingData={false}
                  control={control}
                  error={errors.tipo_formulario}
                  helperText={errors.tipo_formulario?.message}
                  size={gridSizeMdLg12}
                />
            }
          </Grid>
        </Grid>

        <Grid container item {...gridSizeMdLg12} spacing={3} justifyContent={"left"}>
          {
            watchOptionSelected == TipoSolicitudesEnum.CANJE ?
              <>
                {/* <CustomTextField
                size={gridSizeMdLg6}
                label={"NÚMERO DE REGISTRO"}
                error={errors.numero_referencia}
                helperText={errors.numero_referencia?.message}
                control={control}
                name="numero_referencia"
                defaultValue={form.getValues().numero_referencia||""}
              /> */}



                <CustomAutocompleteArrString
                  label="TIPO DE IDENTIFICACIÓN"
                  name="tipo_identificacion"
                  control={form.control}
                  defaultValue={""}
                  options={[TipoIdentificacionEnumChoice.RUC]}
                  isLoadingData={false}
                  error={errors.tipo_identificacion}
                  helperText={errors.tipo_identificacion?.message}
                  size={gridSizeMdLg6}
                  disableClearable
                  onChangeValue={() => {
                    form.setValue('identificacion', '');
                    form.setValue('razon_social', '');
                  }}
                  disabled={!!form.getValues().identificacion}
                />
                <Grid item xs={12} md={6} container spacing={1}>
                  <Grid item xs={12} md={10}>
                    <IdentificacionTextField
                      control={form.control}
                      name="identificacion"
                      label="Identificación"
                      defaultValue={form.getValues().identificacion || ''}
                      error={errors.identificacion}
                      helperText={errors.identificacion?.message}
                      //
                      disabled={!watchedTipoIdentificacion}
                      selectedDocumentType={watchedTipoIdentificacion}
                      onFetchCedulaRucInfo={handleConsultaIdentificacion}
                      size={gridSize}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <SingleIconButton
                      startIcon={<SearchIcon />}
                      label="Buscar"
                      color={'default' as any}
                      onClick={() => {
                        if (
                          !form.getValues().identificacion ||
                          !watchedTipoIdentificacion ||
                          (watchedTipoIdentificacion ===
                            TipoDocumentoNameEnum.CEDULA &&
                            form.getValues().identificacion.length !== 10) ||
                          (watchedTipoIdentificacion === TipoDocumentoNameEnum.RUC &&
                            form.getValues().identificacion.length !== 13)
                        )
                          return setAlert(
                            true,
                            'Ingrese una identificación válida',
                            AlertSeverityEnum.warning
                          );

                        handleConsultaIdentificacion(form.getValues().identificacion);
                      }}
                    />
                  </Grid>
                </Grid>



                {/* <CustomAutocompleteArrString
                  label="Tipo de Servicio"
                  name="servicio"
                  control={form.control}
                  defaultValue={""}
                  options={TIPO_SERVCICIO}
                  isLoadingData={false}
                  error={errors.servicio}
                  helperText={errors.servicio?.message}
                  size={gridSizeMdLg6}
                  disableClearable
                /> */}


                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"NOMBRE CLIENTE"}
                  error={errors.razon_social}
                  helperText={errors.razon_social?.message}
                  control={control}
                  name="razon_social"
                  defaultValue={form.getValues().razon_social || ""}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"RUC/CÉDULA"}
                  error={errors.identificacion}
                  helperText={errors.identificacion?.message}
                  control={control}
                  name="identificacion"
                  defaultValue={form.getValues().identificacion || ""}
                  disabled={isEditPage}
                />
                <CustomAutocomplete<Province>
                  size={gridSizeMdLg6}
                  label={"PROVINCIA"}
                  name="provincia"
                  options={provinceByCountry?.data || []}
                  defaultValue={form.watch().provincia}
                  isLoadingData={isLoadingProvinceByCountry}
                  control={form.control}
                  error={errors.provincia}
                  helperText={errors.provincia?.message}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  onChangeValue={(e) => {
                    setSelectedProvince(e)
                  }}
                  disabled={isEditPage}
                />
                <CustomAutocomplete<City>
                  size={gridSizeMdLg6}
                  label={"CIUDAD"}
                  name="ciudad"
                  options={citiesByProvince?.data?.data || []}
                  defaultValue={form.watch().ciudad}
                  isLoadingData={isLoadingCities}
                  control={form.control}
                  error={errors.ciudad}
                  helperText={errors.ciudad?.message}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  onChangeValue={(e) => {
                    setSelectedCity(e)
                  }}
                  disabled={isEditPage}
                />
                {/* <CustomTextField
                size={gridSizeMdLg6}
                label={"COORDENADAS"}
                error={errors.coordenadas}
                helperText={errors.coordenadas?.message}
                control={control}
                name="coordenadas"
                defaultValue={form.getValues().coordenadas||""}
              /> */}
                <Grid item {...gridSizeMdLg6}>
                  <CustomCoordendasForm
                    form={form}
                    label="COORDENADAS"
                    name="coordenadas"
                    defaultValue={form.watch().coordenadas}
                    key={'key_coordenadas_canje'}
                    onlyValueLocation={true}
                    disabled={isEditPage}
                  />
                </Grid>
                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"DIRECCIÓN"}
                  error={errors.direccion}
                  helperText={errors.direccion?.message}
                  control={control}
                  name="direccion"
                  defaultValue={form.getValues().direccion || ""}
                  disabled={isEditPage}
                />
                <CustomAutocompleteArrString
                  size={gridSizeMdLg6}
                  label={"SERVICIO A CONTRATAR"}
                  name="servicio"
                  options={TIPO_SERVCICIO}
                  defaultValue={form.getValues().servicio ?? ''}
                  isLoadingData={false}
                  control={control}
                  error={form.formState.errors.servicio}
                  helperText={form.formState.errors.servicio?.message}
                  onChangeValue={(e) => {
                    form.reset({
                      ...form.getValues(),
                      servicio: e,
                    });
                  }}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  type="number"
                  label={"ENLACE (Mbps)"}
                  error={errors.capacidad}
                  helperText={errors.capacidad?.message}
                  control={control}
                  name="capacidad"
                  defaultValue={form.getValues().capacidad || ""}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  control={form.control}
                  name="nombre_contacto"
                  label={'NOMBRE DE CONTACTO'}
                  error={errors.nombre_contacto}
                  defaultValue={form.getValues().nombre_contacto || ''}
                  helperText={form.formState.errors.nombre_contacto?.message}
                />
                <CustomTextFieldNumberComponente
                  size={gridSizeMdLg6}
                  type={TiposTextFieldNumberEnum.CELULAR}
                  control={form.control}
                  name="numero_contacto"
                  label={'NÚMERO DE CONTACTO'}
                  error={errors.numero_contacto}
                  defaultValue={form.getValues().numero_contacto || ''}
                  helperText={form.formState.errors.numero_contacto?.message}
                />
                <CustomTextArea
                  size={gridSizeMdLg6}
                  label={"OBSERVACIÓN CANJE"}
                  error={errors.observacion_canje}
                  helperText={errors.observacion_canje?.message}
                  control={control}
                  name="observacion_canje"
                  defaultValue={form.getValues().observacion_canje || ""}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Inspección'
                  control={form.control}
                  name='requiere_inspeccion'
                  defaultValue={!!form.getValues().requiere_inspeccion!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_inspeccion: e })
                  }}
                  disabled={isEditPage}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Cotización'
                  control={form.control}
                  name='requiere_cotizacion'
                  defaultValue={!!form.getValues().requiere_cotizacion!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_cotizacion: e })
                  }}
                  disabled={isEditPage}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Fibra Oscura'
                  control={form.control}
                  name='requiere_fibra_oscura'
                  defaultValue={!!form.getValues().requiere_fibra_oscura!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_fibra_oscura: e })
                  }}
                  disabled={isEditPage}
                />
              </>
              : null
          }







          {
            watchOptionSelected == TipoSolicitudesEnum.EVENTO ?
              <>
                <CustomAutocompleteArrString
                  label="Tipo de identificación"
                  name="tipo_identificacion"
                  control={form.control}
                  defaultValue={""}
                  options={[TipoIdentificacionEnumChoice.RUC]}
                  isLoadingData={false}
                  error={errors.tipo_identificacion}
                  helperText={errors.tipo_identificacion?.message}
                  size={gridSizeMdLg6}
                  disableClearable
                  onChangeValue={() => {
                    form.setValue('identificacion', '');
                    form.setValue('razon_social', '');
                  }}
                  disabled={!!form.getValues().identificacion}
                />
                <Grid item xs={12} md={6} container spacing={1}>
                  <Grid item xs={12} md={10}>
                    <IdentificacionTextField
                      control={form.control}
                      name="identificacion"
                      label="Identificación"
                      defaultValue={form.getValues().identificacion || ''}
                      error={errors.identificacion}
                      helperText={errors.identificacion?.message}
                      //
                      disabled={!watchedTipoIdentificacion}
                      selectedDocumentType={watchedTipoIdentificacion}
                      onFetchCedulaRucInfo={handleConsultaIdentificacion}
                      size={gridSize}
                    />
                  </Grid>
                  <Grid item xs={12} md={2}>
                    <SingleIconButton
                      startIcon={<SearchIcon />}
                      label="Buscar"
                      color={'default' as any}
                      onClick={() => {
                        if (
                          !form.getValues().identificacion ||
                          !watchedTipoIdentificacion ||
                          (watchedTipoIdentificacion ===
                            TipoDocumentoNameEnum.CEDULA &&
                            form.getValues().identificacion.length !== 10) ||
                          (watchedTipoIdentificacion === TipoDocumentoNameEnum.RUC &&
                            form.getValues().identificacion.length !== 13)
                        )
                          return setAlert(
                            true,
                            'Ingrese una identificación válida',
                            AlertSeverityEnum.warning
                          );

                        handleConsultaIdentificacion(form.getValues().identificacion);
                      }}
                    />
                  </Grid>
                </Grid>


                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"NOMBRE DEL EVENTO"}
                  error={errors.nombre}
                  helperText={errors.nombre?.message}
                  control={control}
                  name="nombre"
                  defaultValue={form.getValues().nombre || ""}
                  disabled={isEditPage}
                />
                <CustomAutocompleteArrString
                  label="Tipo de Evento"
                  name="tipo_evento"
                  options={TipoEventoEnumChoice}
                  defaultValue={TipoSolicitudesEnum.EVENTO_GRATUITO}
                  isLoadingData={false}
                  control={control}
                  error={errors.tipo_evento}
                  helperText={errors.tipo_evento?.message}
                  size={gridSizeMdLg6}
                  disabled={isEditPage}
                />
                <SampleDatePicker
                  label="Fecha Inicio de Evento"
                  name="fecha_inicio"
                  control={form.control}
                  defaultValue={null}
                  error={form.formState.errors.fecha_inicio}
                  helperText={form.formState.errors.fecha_inicio?.message}
                  minDate={dayjs()}
                  size={gridSizeMdLg6}
                  disabled={isEditPage}
                />
                <SampleDatePicker
                  label="Fecha Fin de Evento"
                  name="fecha_fin"
                  control={form.control}
                  defaultValue={null}
                  error={form.formState.errors.fecha_fin}
                  helperText={form.formState.errors.fecha_fin?.message}
                  minDate={dayjs()}
                  size={gridSizeMdLg6}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"RESPONSABLE DEL EVENTO"}
                  error={errors.responsable}
                  helperText={errors.responsable?.message}
                  control={control}
                  name="responsable"
                  defaultValue={form.getValues().responsable || ""}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"IDENTIFICACIÓN DE RESPONSABLE DEL EVENTO"}
                  error={errors.identificacion}
                  helperText={errors.identificacion?.message}
                  control={control}
                  name="identificacion"
                  defaultValue={form.getValues().identificacion || ""}
                  disabled={isEditPage}
                />
                <CustomAutocompleteArrString
                  size={gridSizeMdLg6}
                  label={"SERVICIO A CONTRATAR"}
                  name="servicio"
                  options={TIPO_SERVCICIO}
                  defaultValue={form.getValues().servicio ?? ''}
                  isLoadingData={false}
                  control={control}
                  error={form.formState.errors.servicio}
                  helperText={form.formState.errors.servicio?.message}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  control={form.control}
                  name="capacidad"
                  label={'CAPACIDAD'}
                  error={errors.capacidad}
                  defaultValue={form.getValues().capacidad || ''}
                  helperText={form.formState.errors.capacidad?.message}
                  disabled={isEditPage}
                />
                <CustomAutocomplete<Province>
                  size={gridSizeMdLg6}
                  label={"PROVINCIA"}
                  name="provincia"
                  options={provinceByCountry?.data || []}
                  defaultValue={form.watch().provincia}
                  isLoadingData={isLoadingProvinceByCountry}
                  control={form.control}
                  error={errors.provincia}
                  helperText={errors.provincia?.message}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  onChangeValue={(e) => {
                    setSelectedProvince(e)
                  }}
                  disabled={isEditPage}
                />
                <CustomAutocomplete<City>
                  size={gridSizeMdLg6}
                  label={"CIUDAD"}
                  name="ciudad"
                  options={citiesByProvince?.data?.data || []}
                  defaultValue={form.watch().ciudad}
                  isLoadingData={isLoadingCities}
                  control={form.control}
                  error={errors.ciudad}
                  helperText={errors.ciudad?.message}
                  valueKey="nombre" // name is the fk
                  actualValueKey="codigo"
                  onChangeValue={(e) => {
                    setSelectedCity(e)
                  }}
                  disabled={isEditPage}
                />

                <Grid item {...gridSizeMdLg6}>
                  <CustomCoordendasForm
                    form={form}
                    label="COORDENADAS"
                    name="coordenadas"
                    defaultValue={form.watch().coordenadas}
                    key={'key_coordenadas_canje'}
                    onlyValueLocation={true}
                    disabled={isEditPage}
                  />
                </Grid>
                <CustomTextField
                  size={gridSizeMdLg6}
                  label={"DIRECCIÓN"}
                  error={errors.direccion}
                  helperText={errors.direccion?.message}
                  control={control}
                  name="direccion"
                  defaultValue={form.getValues().direccion || ""}
                  disabled={isEditPage}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  control={form.control}
                  name="nombre_contacto"
                  label={'NOMBRE DE CONTACTO'}
                  error={errors.nombre_contacto}
                  defaultValue={form.getValues().nombre_contacto || ''}
                  helperText={form.formState.errors.nombre_contacto?.message}
                />
                <CustomTextField
                  size={gridSizeMdLg6}
                  type='number'
                  control={form.control}
                  name="numero_contacto"
                  label={'NÚMERO DE CONTACTO'}
                  error={errors.numero_contacto}
                  defaultValue={form.getValues().numero_contacto || ''}
                  helperText={form.formState.errors.numero_contacto?.message}
                />
                <CustomTextArea
                  size={gridSizeMdLg6}
                  label={"OBSERVACIÓN EVENTO"}
                  error={errors.observacion_evento}
                  helperText={errors.observacion_evento?.message}
                  control={control}
                  name="observacion_evento"
                  defaultValue={form.getValues().observacion_evento || ""}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Inspección'
                  control={form.control}
                  name='requiere_inspeccion'
                  defaultValue={!!form.getValues().requiere_inspeccion!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_inspeccion: e })
                  }}
                  disabled={isEditPage}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Cotización'
                  control={form.control}
                  name='requiere_cotizacion'
                  defaultValue={!!form.getValues().requiere_cotizacion!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_cotizacion: e })
                  }}
                  disabled={isEditPage}
                />
                <SampleCheckbox
                  size={gridSizeMdLg3}
                  label='Requiere Fibra Oscura'
                  control={form.control}
                  name='requiere_fibra_oscura'
                  defaultValue={!!form.getValues().requiere_fibra_oscura!}
                  onChangeValue={(e: any) => {
                    form.reset({ ...form.getValues(), requiere_fibra_oscura: e })
                  }}
                  disabled={isEditPage}
                />
              </>
              : null
          }
        </Grid>

      </SingleTableBoxScene>
    </>
  )
}